<template>
  <v-main>
    <router-view />
    <div class="text-center">
      <v-overlay :value="loadingNegocioGest" z-index="10">
        <v-btn color="orange lighten-2">Cargando negocio</v-btn>
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-overlay>
    </div>
    <sheet-loading />
    <generar-catalogo-fab />
    <dashboard-core-footer />
  </v-main>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "DashboardCoreView",

  components: {
    DashboardCoreFooter: () => import("./Footer"),
    SheetLoading: () => import("./SheetLoading"),
    GenerarCatalogoFab: () => import("@/components/negocio/GenerarCatalogoFab"),
  },
  computed: {
    ...mapState({
      loadingNegocioGest: (state) => state.app.loadingNegocioGest,
    }),
  },
};
</script>
